import { render, staticRenderFns } from "./printQuestionAnswerDetailList.vue?vue&type=template&id=37768b61&scoped=true"
import script from "./printQuestionAnswerDetailList.vue?vue&type=script&lang=js"
export * from "./printQuestionAnswerDetailList.vue?vue&type=script&lang=js"
import style0 from "./printQuestionAnswerDetailList.vue?vue&type=style&index=0&id=37768b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37768b61",
  null
  
)

export default component.exports